import Axios from '../utils/axios-utils';

// create Renewal
export const createRenewal = async (data, accountId) => {
    try {
        const response = await Axios.post(`/accounts/${accountId}/renewals`, {
            vehicleId: data.vehicleId,
            vendorId: data.vendorId,
            lineageId: data.lineageId,
            type: data.type,
            startTime: data.startTime,
            endTime: data.endTime,
            remind: data.remind,
            amount: data.amount,
            note: data.note,
            context: data.context
        });

        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Create renewals error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Create renewals failed" }
        };
    }
};

// get all Renewal
export const getAllRenewals = async (accountId, from, to) => {
    try {
        // const response = await Axios.get(`/accounts/${accountId}/renewals`, {
        //     params: { from, to },
        // });
        const response = await Axios.get(`/accounts/${accountId}/renewals`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All renewals error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All renewals failed" }
        };
    }
};

// get all Renewal types
export const getAllRenewalTypes = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/renewals/types`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All renewals types error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All renewals types failed" }
        };
    }
};

// delete Renewal
export const deleteRenewal = async (accountId, renewalId) => {
    try {
        const response = await Axios.delete(`/accounts/${accountId}/renewals/${renewalId}`);

        return {
            success: response.data.status === 'success',
            data: response.data,
            status: response.status
        };
    } catch (error) {
        console.log("Delete renewal error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Delete renewal failed" },
            status: error.response?.status || 500
        };
    }
};

// update renewal
export const updateRenewal = async (accountId, renewalId, data) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/renewals/${renewalId}`, data);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update renewal error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update renewal failed" }
        };
    }
};


// update renewal status
export const updateRenewalStatus = async (accountId, renewalId, status) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/renewals/${renewalId}/status`, {
            status,
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update renewal Status error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update renewal Status failed" }
        };
    }
};


// get  renewal media
export const getRenewalMedia = async (accountId, renewalId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/renewals/${renewalId}/media`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get renewal media error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get renewal media failed" }
        };
    }
};